<!--coupons-->
<div class="coupon">
  <form #couponForm="ngForm" (ngSubmit)="couponForm.form.valid;">
    <div class="card-field-group">
      <div>
        <label class="promo-label">{{ 'CARD_PAYEMENT.COUPON_LABEL_NAME' | translate }}</label>
        <div class="promo">
          <svg *ngIf="!this.successMessage" id="Capa_1" enable-background="new 0 0 551.13 551.13" height="20pt"
            viewBox="0 0 551.13 551.13" width="20pt" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m275.565 0c-151.944 0-275.565 123.621-275.565 275.565s123.621 275.565 275.565 275.565 275.565-123.621 275.565-275.565-123.621-275.565-275.565-275.565zm0 516.685c-132.955 0-241.119-108.164-241.119-241.119s108.164-241.12 241.119-241.12 241.12 108.164 241.12 241.119-108.165 241.12-241.12 241.12z" />
            <path d="m241.119 337.325-73.937-73.937-24.354 24.354 98.291 98.291 167.183-167.183-24.354-24.354z" /></svg>

          <svg *ngIf="this.successMessage" id="Capa_1" enable-background="new 0 0 551.13 551.13" height="20pt"
            viewBox="0 0 551.13 551.13" width="20pt" xmlns="http://www.w3.org/2000/svg">
            <path fill="green"
              d="m275.565 0c-151.944 0-275.565 123.621-275.565 275.565s123.621 275.565 275.565 275.565 275.565-123.621 275.565-275.565-123.621-275.565-275.565-275.565zm0 516.685c-132.955 0-241.119-108.164-241.119-241.119s108.164-241.12 241.119-241.12 241.12 108.164 241.12 241.119-108.165 241.12-241.12 241.12z" />
            <path fill="green"
              d="m241.119 337.325-73.937-73.937-24.354 24.354 98.291 98.291 167.183-167.183-24.354-24.354z" />
          </svg>

          <input type="text" name="coupon" #coupon="ngModel" required placeholder="Enter the coupon code....."
            class="card-input" [(ngModel)]="code" (keyup)="removeSpace()" [disabled]="disableTextbox">
          <svg *ngIf="code" class="close-icon" (click)="clearValue()" id="Capa_2"
            enable-background="new 0 0 413.348 413.348" height="20" viewBox="0 0 413.348 413.348" width="20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z" />
          </svg>
          <span class="error" *ngIf="errorMessage != ''">{{errorMessage}}</span>
        </div>
        <div [hidden]="isHidden">
          <button (click)="handleCoupon()" class="org-btn wave"
            [disabled]="submitted">{{ 'CARD_PAYEMENT.COUPON_BUTTON_NAME' | translate }}</button>
        </div>
      </div>
    </div>
  </form>
  <div [hidden]="!isHidden" class="success-message">
    <span class="success" *ngIf="successMessage!=''">{{successMessage}}</span>
    <span *ngIf="this.successMessage" class="message">{{ 'CARD_PAYEMENT.COUPON_SUCCESS_MESSAGE' | translate }}
      <i>${{calculation}}</i> </span>
  </div>
</div>
<!--end of the coupons-->